var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLongArrowLeft = function SvgLongArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.11 9.664 4.359-4.482L9.319 4 3 10.5 9.32 17l1.149-1.182-4.359-4.482H70V9.664H6.11Z",
    fill: "var(--native-icon-fill)"
  })));
};

export default SvgLongArrowLeft;